<template>
  <div
    class="myCollect"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="loading"
    infinite-scroll-distance="10"
  > 
  <div class="hander">
        <van-icon name="arrow-left" @click="goBack" class='nav_goback' />
      </div>
    <div v-if="!list.length" style="padding-top:200px;font-size:18px;color:#999;text-align:center" >暂无数据</div>
    <div class="goodsbox" v-for="item in list" :key="item.id">
      <Goods :goods="item" />
      <img src="../assets/my/del.png" @click="delCollect(item.id)" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.myCollect {
  .goodsbox {
    display: flex;
    align-items: center;
    background-color: #fff;
    img {
      width: 36px;
      margin: 0 10px 0 24px;
    }
  }
  .hander{
        width: 55px;
        height: 55px;
        border-radius: 50%;
        background-color: rgba(255,255,255,.6);
        margin-bottom: 10px;
      }
}
</style>

<script>
import Goods from "../component/MyGoodsTemplate";
export default {
  components: {
    Goods
  },
  data() {
    return {
      page: 1,
      loading: false,
      list: [],
      no_data:false
    };
  },
  created() {
    this.getMyCollect();
  },
  methods: {
    // 获取我的收藏数据
    getMyCollect() {
      this.$http({
        url: "goodsCollectionList",
        data: {
          page: this.page
        }
      }).then(res => {
        if(!res._list.length) return this.no_data = true

        let list = this.page == 1 ? res._list : this.list.concat(res._list);
        this.list = list;
        this.page = ++res.nowPage;
      });
    },

    delCollect(id) {
      this.$dialog
        .confirm({
          message: "是否取消收藏"
        })
        .then(() => {
          this.$http({
            url: "delCollection",
            data: {
              id
            }
          }).then(res => {
            this.list = this.list.filter(item=>item.id != id);
          });
        });
    },
    loadMore() {
      if(this.no_data) return 
      this.loading = true;
      
      setTimeout(() => {
        this.getMyCollect();
        this.loading = false;
      }, 2500);
    }
  }
};
</script>
